<template>
	<b-modal ref="userBirthdayModal" id="userBirthdayModal" hide-footer hide-header no-close-on-backdrop no-close-on-esc centered>
		<div class="form-group p-2 p-md-4">
			<div class="text-center">
				<div class="award-info flex-fill mb-4">
					<div class="flex-fill m-auto">
						<b>+</b>
						<span>
							<img src="/images/shop/mts-points/2.png" />
						</span>
						<b>{{ config.birthDateGiftMtsPoints }}</b>
					</div>
				</div>
			</div>
			<div class="form-group text-center">
				<h4 class="mx-3">{{ $t('birth_day_popup.title') }}</h4>
			</div>
			<div class="row mb-4">
				<div class="col-6">
					<b-select v-model="selectedMonth" @input="updateDays" class="text-center" name="month">
						<option :key="0" :value="null" disabled>
							{{ $t('base.date_month') }}
						</option>
						<option v-for="month in [...Array(12).keys()].map((n) => n + 1)" :key="month" :value="month">
							{{ month }}
						</option>
					</b-select>
				</div>
				<div class="col-6">
					<b-select v-model="selectedDay" class="text-center" name="day">
						<option :key="0" :value="null" disabled>
							{{ $t('base.date_day') }}
						</option>
						<option v-for="day in daysInMonth" :key="day" :value="day">
							{{ day }}
						</option>
					</b-select>
				</div>
			</div>
			<div class="row">
				<div class="col-6">
					<b-button
						@click="
							hide()
							btnSfx()
						"
						type="button"
						variant="yellow"
						size="lg"
						block
						>{{ $t('birth_day_popup.btn_cancel') }}</b-button
					>
				</div>
				<div class="col-6">
					<b-button
						@click="
							submit()
							btnSfx()
						"
						type="button"
						variant="success"
						size="lg"
						block
						>{{ $t('birth_day_popup.btn_submit') }}</b-button
					>
				</div>
			</div>
		</div>
	</b-modal>
</template>
<script>
import Vue from 'vue'
import api from '../../api'

const BirthdayPopup = Vue.component('birthday-popup', {
	data() {
		return {
			selectedMonth: null,
			selectedDay: null,
			daysInMonth: [],
		}
	},
	computed: {
		user() {
			return this.$store.state.auth.user
		},
		config() {
			return this.$store.state.config.data
		},
	},
	methods: {
		btnSfx() {
			this.$store.dispatch('sound/sfx', 'Button')
		},
		show() {
			this.$refs.userBirthdayModal.show()
		},
		hide() {
			this.$refs.userBirthdayModal.hide()
			const tryCount = parseInt(localStorage.getItem('userBirtDayGetTry') ?? 0, 10)

			if (tryCount > 2) {
				let loader = document.getElementById('loader')
				loader.classList.add('show')

				api.setSettings({ birthDateOptOut: false })
					.then((response) => {
						// console.log("No offer input for birth date");
					})
					.catch((error) => {
						api.baseErrorHendler(error)
					})
					.then((res) => {
						loader.classList.remove('show')
					})
			} else {
				localStorage.setItem('userBirtDayGetTry', tryCount + 1)
			}
		},
		isLeapYear(year) {
			return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
		},
		updateDays() {
			const month = this.selectedMonth
			const year = this.user.birthYear
			let days

			if ([1, 3, 5, 7, 8, 10, 12].includes(month)) {
				days = 31
			} else if ([4, 6, 9, 11].includes(month)) {
				days = 30
			} else if (month === 2) {
				days = this.isLeapYear(year) ? 29 : 28
			}

			this.daysInMonth = Array.from({ length: days }, (_, i) => i + 1)

			if (this.selectedDay > days) {
				this.selectedDay = null
			}
		},
		submit() {
			let $this = this
			if (!this.selectedDay || !this.selectedMonth) return

			const pad = (n) => String(n).padStart(2, '0')
			const birthDate = `${this.user.birthYear}-${pad(this.selectedMonth)}-${pad(this.selectedDay)}`

			let loader = document.getElementById('loader')
			loader.classList.add('show')

			api.updateMe({ birthDate })
				.then((response) => {
					$this.$root.$bvModal
						.msgBoxOk(this.htmlToVNode($this.$t('birthday_added_popup.sub_text', { mts_points: $this.config.birthDateGiftMtsPoints })), {
							title: $this.$t('birthday_added_popup.title'),
							size: 'sm',
							buttonSize: 'lg',
							okTitle: $this.$t('base.btn_ok'),
							modalClass: 'confirmModal',
							hideHeaderClose: false,
							centered: true,
						})
						.then((r) => {
							$this.$store.dispatch('sound/sfx', 'Button')
						})
					$this.hide()
				})
				.catch((error) => {
					api.baseErrorHendler(error)
				})
				.then((res) => {
					loader.classList.remove('show')
				})
		},
		htmlToVNode(html) {
			return [this.$createElement('div', { domProps: { innerHTML: html } })]
		},
	},
	watch: {
		selectedMonth: 'updateDays',
	},
})

export default BirthdayPopup
</script>
